export default __webpack_public_path__ + "static/media/hellobank.5730afb8.png";